import BaseCtrl from 'edge/platform/base/BaseCtrl';
import SessionUtil from 'edge/quoteandbind/common/util/SessionUtil';

var fn = function fn($scope, $state, $rootElement, StateUtils, LocaleService, ViewModelService, ModalService, BOPCoverablesService, $stateParams) {
    var ctrl = Object.create(BaseCtrl);
    var model = StateUtils.activeDataForState(true).model;

    var back = function back() {
        return $state.go($stateParams.initialPage, {
            locationId: $scope.resultingLocationId
        });
    };

    ctrl.init = function () {
        $rootElement.scrollTop(0);

        $scope.transactionID = model.quoteID ? model.quoteID.value : model.jobID.value;
        $scope.businessOwners = model.lobData.businessOwners;
        $scope.locations = $scope.businessOwners.coverables.locations.value;
        $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
        resetLocation();

        $scope.back = function () {
            if ($scope.newLocationForm.$pristine) {
                // Nothing changed, no need for confirmation
                return back();
            }

            // Confirm before wiping info
            ModalService.showWarning('gw-portals-bop-components-angular.locationsAndBuildings.location.locationCtrl.Information will be lost', 'gw-portals-bop-components-angular.locationsAndBuildings.location.locationCtrl.Do you want to discard changes made to the location?').result.then(back);
        };

        $scope.save = function (form) {
            form.submitted = true;
            if (form.invalid) {
                return;
            }
            ctrl.addNewLocation(form);
        };
    };

    function resetLocation() {
        $scope.location = {
            address: {},
            buildings: []
        };
        $scope.locationView = ViewModelService.create($scope.location, 'pc', 'edge.capabilities.policyjob.lob.businessowners.coverables.dto.LocationDTO');
    }

    ctrl.addNewLocation = function () {

        var newLocation = $scope.locationView.value;
        newLocation.displayName = formatDisplayName(newLocation);

        $scope.operation = BOPCoverablesService.addBOPLocation($scope.transactionID, newLocation, SessionUtil.getSessionUUID(model));
        $scope.operation.then(function (result) {
            $scope.locations.push(result);
            $scope.resultingLocationId = result.publicID;
            back();
        }).catch(function () {
            ModalService.showError('gw-portals-bop-components-angular.locationsAndBuildings.location.locationCtrl.Unable to add location', 'gw-portals-bop-components-angular.locationsAndBuildings.location.locationCtrl.Please check for errors and try again');
        });
    };

    function formatDisplayName(location) {
        return location.address.addressLine1 + ', ' + location.address.city + ', ' + location.address.postalCode + ', ' + location.address.state;
    }

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', '$rootElement', 'StateUtils', 'LocaleService', 'ViewModelService', 'ModalService', 'qnb.bopCoverablesService', '$stateParams'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-bop-components-angular/locationsAndBuildings/location/locationCtrl.js
// module id = 1812
// module chunks = 0